document.addEventListener("DOMContentLoaded", function () {
	function getClassNumber(element, prefix, min = 1, max = 6, fallback = 1) {
		for (let i = min; i <= max; i++) {
			if (element.classList.contains(prefix + i)) {
				return i;
			}
		}
		return fallback;
	}

	function copyAttributes(source, target, exclude = ["class"]) {
		Array.from(source.attributes).forEach((attr) => {
			if (!exclude.includes(attr.name)) {
				target.setAttribute(attr.name, attr.value);
			}
		});
	}

	function replaceQueryLoopLists() {
		document
			.querySelectorAll("ul.carousel.wp-block-post-template")
			.forEach((ul) => {
				const div = document.createElement("div");

				div.className = ul.className;
				copyAttributes(ul, div);

				Array.from(ul.children).forEach((child) => {
					if (child.tagName === "LI") {
						const slideDiv = document.createElement("div");

						slideDiv.className = child.className;
						copyAttributes(child, slideDiv);
						slideDiv.innerHTML = child.innerHTML;

						div.appendChild(slideDiv);
					} else {
						div.appendChild(child.cloneNode(true));
					}
				});

				ul.parentNode.replaceChild(div, ul);
			});
	}

	function parseGapValue(val) {
		val = (val || "").trim();

		if (!val) return 0;

		const parts = val.split(/\s+/);
		const lastPart = parts[parts.length - 1];

		const clampMatch = lastPart.match(/clamp\(([^,]+),/);
		if (clampMatch) {
			const pxMatch = clampMatch[1].match(/(\d+(\.\d+)?)\s*px/);
			if (pxMatch) return parseFloat(pxMatch[1]);
		}

		const pxMatch = lastPart.match(/(\d+(\.\d+)?)\s*px/);
		if (pxMatch) return parseFloat(pxMatch[1]);

		return 0;
	}

	function createNavButtons(carousel) {
		const prevBtn = document.createElement("div");
		const nextBtn = document.createElement("div");

		prevBtn.className = "swiper-button-prev";
		nextBtn.className = "swiper-button-next";

		// Insert the buttons inside the carousel element so we can position
		// them relative to the carousel and the inner wrapper.
		const wrapper = carousel.querySelector('.swiper-wrapper');
		if (wrapper) {
			carousel.insertBefore(prevBtn, wrapper);
			carousel.insertBefore(nextBtn, wrapper.nextSibling);
		} else {
			// Fallback: insert as children at the start/end
			carousel.insertBefore(prevBtn, carousel.firstChild);
			carousel.appendChild(nextBtn);
		}

		return { prevBtn, nextBtn };
	}



	function createPagination(carousel) {
		const pagination = document.createElement("div");
		pagination.className = "swiper-pagination";
		carousel.appendChild(pagination);
		return pagination;
	}

	function buildSwiperStructure(carousel) {
		carousel.classList.add("swiper");

		const wrapper = document.createElement("div");
		wrapper.classList.add("swiper-wrapper");

		Array.from(carousel.children).forEach((child) => {
			child.classList.add("swiper-slide");
			wrapper.appendChild(child);
		});

		carousel.textContent = "";
		carousel.appendChild(wrapper);
	}

	function initCarousel(carousel) {
		const desktopSlidesPerView = getClassNumber(carousel, "show-", 1, 6, 1);
		const slidesPerGroup = getClassNumber(carousel, "scroll-", 1, 6, 1);
		const slideCount = carousel.children.length;
		const spaceBetween = parseGapValue(getComputedStyle(carousel).gap);

		const hasArrows = carousel.classList.contains("has-arrows");
		const hasDots = carousel.classList.contains("has-dots");
		const isInfinite = carousel.classList.contains("is-infinite");
		const isVertical = carousel.classList.contains("is-vertical");
		const willAutoplay = carousel.classList.contains("will-autoplay");
		const willFade = carousel.classList.contains("will-fade");

		buildSwiperStructure(carousel);

		// Create controls only if they could be useful at any breakpoint.
		// Since mobile defaults to 1 slide per view, anything with more than
		// one slide can overflow on mobile.
		const shouldCreateNavigation = hasArrows && slideCount > 1;
		const shouldCreatePagination = hasDots && slideCount > 1;

		const navigation = shouldCreateNavigation
			? createNavButtons(carousel)
			: null;

		const pagination = shouldCreatePagination
			? createPagination(carousel)
			: null;



		const swiperOptions = {
			loop: isInfinite && slideCount > 1,
			direction: isVertical ? "vertical" : "horizontal",
			autoplay: willAutoplay
				? bds_theme.features.carousels.swiper_opts.autoplay
				: false,
			effect: willFade ? "fade" : "slide",
			slidesPerView: 1,
			slidesPerGroup: 1,
			speed: bds_theme.features.carousels.swiper_opts.speed,
			spaceBetween: spaceBetween,
			watchOverflow: true,
			navigation: navigation
				? {
						nextEl: navigation.nextBtn,
						prevEl: navigation.prevBtn,
					}
				: false,
			pagination: pagination
				? {
						el: pagination,
						clickable: true,
					}
				: false,
			breakpoints: {
				782: {
					slidesPerView: desktopSlidesPerView,
					slidesPerGroup: slidesPerGroup,
				},
			},
		};

		if (willFade) {
			swiperOptions.fadeEffect =
				bds_theme.features.carousels.swiper_opts.fade_effect;
		}

		new Swiper(carousel, swiperOptions);
	}

	replaceQueryLoopLists();

	document
		.querySelectorAll(".carousel, .is-style-carousel")
		.forEach(initCarousel);
});
